import { Checkbox, useToast } from '@chakra-ui/react'
import {
  DocumentReference,
  arrayRemove,
  arrayUnion,
  updateDoc,
} from 'firebase/firestore'
import FirestoreUser, {
  Role,
  RoleChange,
  roleTitles,
} from '../../../../types/FirestoreUser'
import { primaryServices } from '../../../../utils/firebaseServiceContext'

export const RoleCheckbox = ({
  role,
  user,
  docRef: ref,
  isDisabled,
  adminName,
}: {
  role: Role
  user: FirestoreUser
  docRef: DocumentReference
  isDisabled?: boolean
  adminName: string
}) => {
  const checked = user?.roles?.includes(role) || false
  const toast = useToast()

  return (
    <Checkbox
      isChecked={checked}
      isDisabled={isDisabled}
      onChange={() => {
        const currentUser = primaryServices.auth.currentUser
        if (
          // ['admin', 'superadmin'].includes(role) &&
          ref.id === currentUser?.uid
        ) {
          return toast({
            status: 'warning',
            title: 'Warning',
            description: "You can't change your own admin status!",
          })
        }

        // Create role change history entry
        const roleChange: RoleChange = {
          role: role,
          action: checked ? 'removed' : 'added',
          changedBy: adminName,
          changedAt: new Date().toISOString(),
        }

        // Update both roles and roleChangeHistory
        updateDoc(ref, {
          roles: checked ? arrayRemove(role) : arrayUnion(role),
          roleChangeHistory: arrayUnion(roleChange),
        })
          .then(() => {
            toast({
              status: 'success',
              title: 'Role updated',
              description: `${roleTitles[role]} role ${
                checked ? 'removed' : 'added'
              } successfully`,
              duration: 3000,
            })
          })
          .catch((error) => {
            console.error('Error updating role:', error)
            toast({
              status: 'error',
              title: 'Error updating role',
              description: error.message || 'An unexpected error occurred',
              duration: 5000,
            })
          })
      }}
    >
      {roleTitles[role]}
    </Checkbox>
  )
}
